var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path4, _path5, _path6, _circle9, _circle10, _path7, _path8, _path9, _circle11, _path10, _path11, _path12, _path13, _path14, _circle12, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawToTheMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 693,
    height: 616,
    viewBox: "0 0 693 616",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M929.6,399.75c-11.9,96.32-74.08,181.71-153.68,237.23q-9.68994,6.765-19.86,12.98c-.85.52-1.7,1.04-2.55,1.55-47.3,28.38-101.49,46.56-155.93,40.89-44.23-4.6-87.66-28.13-113.58-63.28-.49-.66-.98-1.34-1.45-2.01a121.42808,121.42808,0,0,1-20.96-49.22c-4.66-26.29-1.04-55.36-15.52-77.79-18.78-29.1-59-33.84-93.61-32.75-32.35,1.01-64.65,4.51-96.96,6.33-.66.04-1.33.07-2,.11V164.69A22.71737,22.71737,0,0,1,276.19,142H416.92c6.81.89,11.63,14.55,18.42005,15q4.41.3,8.81.48c15.43.64,30.84.37,46.23-.48,8.99-.49,19.98-14.18,28.96-15H779.2c1.94.64,3.86,1.31,5.78,2a214.75742,214.75742,0,0,1,24.2,10.44C895.74,198.33,941.5,303.43,929.6,399.75Z",
    transform: "translate(-253.5 -142)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M820.89,271.14c-40.29,37.5-93.66,61.56-148.48,67.33q-8.06991.855-16.18,1.17c-1.19995.05-2.4.08-3.61.11-1.96.05-3.93.07-5.89.07q-3.525,0-7.05-.1a255.88354,255.88354,0,0,1-40.52-4.43c-.49-.1-.97-.19-1.46-.29q-3.165-.615-6.31-1.32-6.03-1.335-12-2.96c-1.29-.35-2.58-.71-3.87-1.09-1.85-.53-3.69-1.09-5.53-1.66-.69-.22-1.38-.43-2.07-.66q-1.05-.33-2.1-.69-6.405-2.1-12.7-4.56a255.24182,255.24182,0,0,1-66.37-37.91c-2.78-2.21-5.6-4.53-8.32-6.78-14.62-12.06-29.74-24.53-48.17-27.25-19.9-2.93-39.02,6.13-57.5,14.89-6.27,2.97-12.75,6.04-19.16,8.61a152.67089,152.67089,0,0,1-98.1,4.69c-.67-.18-1.34-.38-2-.58v-2.09c.66.2,1.33.4,2,.59a150.75325,150.75325,0,0,0,97.36-4.47c6.35-2.54,12.81-5.6,19.05-8.56,18.75-8.89,38.14-18.08,58.64-15.06,18.98,2.8,34.32,15.45,49.15,27.69,2.72,2.24,5.53,4.56,8.29,6.76a253.09188,253.09188,0,0,0,65.94,37.65h.01c4.02,1.56,8.09,3.03,12.18,4.39.59.19,1.18.38,1.77.58.66.21,1.33.42,1.99.63q2.535.81,5.08,1.54,2.49.75,5.01,1.42h.01q6.45008,1.755,12.98,3.17c1.97.44,3.94.84,5.93,1.22.43.09.87.17,1.31.25a252.999,252.999,0,0,0,38.86,4.26h.01q6.795.20994,13.57.05c1.18-.03,2.35-.07,3.52-.11q7.66508-.3,15.31-1.08h.01c54.65-5.59,107.89-29.51,148.05005-66.89a1.00132,1.00132,0,0,1,1.36,1.47Z",
    transform: "translate(-253.5 -142)",
    fill: "#6c63ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.81,232.94a2.30973,2.30973,0,0,1-.31.72v-2.79A2.819,2.819,0,0,1,253.81,232.94Z",
    transform: "translate(-253.5 -142)",
    fill: "#ff6584"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.43895,
    cy: 243.27926,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-264.64557 332.0982) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.22187,
    cy: 264.4871,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-283.24836 353.71669) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 753.4425,
    cy: 432.59418,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-104.48422 914.67884) rotate(-75.77932)",
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 719.59887,
    cy: 432.37602,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-129.80244 881.70773) rotate(-75.77932)",
    fill: "#3f3d56"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 759.79349,
    cy: 460.67263,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-126.91144 942.01599) rotate(-75.77932)",
    fill: "#ff6584"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 770.43895,
    cy: 472.27926,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-37.97424 1043.50799) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 773.22187,
    cy: 493.4871,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-56.57703 1065.12648) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 738.62158,
    cy: 453.07117,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-47.16909 994.81233) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 755.65329,
    cy: 446.67272,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-25.66983 1006.05077) rotate(-83.62433)",
    fill: "#ff6584"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 734.67098,
    cy: 429.38621,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-27.14252 969.83133) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.4425,
    cy: 195.59418,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-217.97261 294.8423) rotate(-75.77932)",
    fill: "#fff"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.59887,
    cy: 195.37602,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-243.29083 261.87118) rotate(-75.77932)",
    fill: "#3f3d56"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.79349,
    cy: 223.67263,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-240.39983 322.17945) rotate(-75.77932)",
    fill: "#ff6584"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.43895,
    cy: 235.27926,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-206.91368 380.64022) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.22187,
    cy: 256.4871,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-225.51647 402.25871) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.62158,
    cy: 216.07117,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-216.10854 331.94456) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.65329,
    cy: 209.67272,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-194.60927 343.183) rotate(-83.62433)",
    fill: "#ff6584"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.67098,
    cy: 192.38621,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-196.08196 306.96356) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158.3728,
    cy: 194.09532,
    r: 4,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3728,
    cy: 234.09532,
    r: 2,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.3728,
    cy: 383.09532,
    r: 2,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.3728,
    cy: 291.09532,
    r: 2,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.3728,
    cy: 82.09532,
    r: 2,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.3728,
    cy: 159.09532,
    r: 2,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.3728,
    cy: 55.09532,
    r: 2,
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 461.3728,
    cy: 43.09532,
    r: 4,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M893.87,716.6h-2c0-11.54-10.81-22.83-32.14-33.56-20.87-10.5-50.79-19.94-88.91-28.05q-8.46-1.8-17.31-3.48c-30.52-5.8-64.43-10.55-100.75-14.16q-11.265-1.125-22.85-2.09c-2.5-.22-5.02-.42-7.55-.63q-10.545-.82506-21.31-1.54c-37.46-2.48-76.79-3.83-117.05-3.97-2.37-.02-4.75-.02-7.13-.02-52.43,0-64.27,4.95-64.97,9.11-1.79,10.52,58.85,31.65,117.49,52.1C594.3,712.93,661.01,736.19,683.73,756c.77.67,1.49,1.34,2.16,2h-2.75c-.73-.66-1.52-1.33-2.36-2C656.79,736.84,589.5,713.38,528.73,692.19c-74.94-26.12-120.77-42.72-118.81-54.32.85-5.02,9.23-10.77,66.95-10.77,1.89,0,3.79,0,5.68.01,40.25.11,79.58,1.43,117.08,3.89q10.995.705,21.77,1.56c2.67.21,5.33.42,7.98.65q11.88.99006,23.45,2.14c37.28,3.7,72.05,8.6,103.23,14.61q7.74,1.5,15.18,3.08C850.32,669.86,893.87,692.43,893.87,716.6Z",
    transform: "translate(-253.5 -142)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M862.8728,711.77891h-2c0-8.54-34.88818-17.68359-86.8247-17.68359-51.936,0-86.82422,9.14355-86.82422,17.68359h-2c0-12.32129,45.16211-19.68359,88.82422-19.68359S862.8728,699.45762,862.8728,711.77891Z",
    transform: "translate(-253.5 -142)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M827.97583,717.59532h-2c0-4.82324-21.20654-10.19824-51.63672-10.19824s-51.63672,5.375-51.63672,10.19824h-2c0-7.92285,27.63477-12.19824,53.63672-12.19824S827.97583,709.67247,827.97583,717.59532Z",
    transform: "translate(-253.5 -142)",
    fill: "#e6e6e6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.3728,
    cy: 94.09532,
    r: 40,
    fill: "#f2f2f2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.3728,
    cy: 97.09532,
    r: 40,
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M651.8722,677.04048,614.38,677.03905V676.565a14.59383,14.59383,0,0,1,14.593-14.5928h.00091l6.84841-5.19554L648.6,661.973l3.27284.00007Z",
    transform: "translate(-253.5 -142)",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M634.41905,656.791l-32.03268,19.48267-.24638-.40506a14.59381,14.59381,0,0,1,4.88417-20.0512l.00077-.00047,3.151-7.99784,13.61718-2.20069,2.79623-1.70076Z",
    transform: "translate(-253.5 -142)",
    fill: "#f2f2f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M656.44281,550.56529c-.17,1.19995-.42,5.28-.71,11.22-1.41,28.80005-3.86,101.31006-3.86,101.31006l-15.27-4.75s-18.16-54.78-15.16-84.78l-2.16-10.43994-3.7-17.84009v-.01l-11.27-54.33s-2.47,14.7201-2.67,18.17005-2.2,4.45-3.2,4.45c-5.01,0-3.47-.89-2.74,4.06006.53,3.55993-3.81,23.97-6.29,35.12988-.96,4.34009-1.64,7.28-1.64,7.28l4.24,9.14,35.15,75.80005-13.29,7.12-53.02-78.58008-5.23-7.75-1.12-8.68994-8.82-68.37s-2.75-7.73,0-7.93c2.76-.21,4.32.66,3.54-2.27-.78-2.93994,15.22-51.93994,15.22-51.93994l83,18s8.18,16.26,5,24c-3.19,7.74,2.61,67.67993-.7,70.34009-3.3,2.65991-5.43.5299-.87,5.09985a8.38635,8.38635,0,0,0,2.43,1.76C656.1228,547.04527,657.2428,544.96531,656.44281,550.56529Z",
    transform: "translate(-253.5 -142)",
    fill: "#f2f2f2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.11277,
    cy: 98.95991,
    r: 23.0557,
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M625.57956,260.81621l-9.14,1.75s8.5-13.72,8-20c-.5-6.28-7.34-8.53-7.34-8.53s-3.79.82-7.78,1.28a20.0611,20.0611,0,0,0-1.85-3.85,6.71583,6.71583,0,0,1-1.96,4.14,10.93526,10.93526,0,0,1-4.33-.5c-1.58-.72-1.55-1.97-1.03-3.14a41.62375,41.62375,0,0,0-14.82,4.07,40.8988,40.8988,0,0,1,.35-9.2c.22-.06.44-.12994.66-.2a20.41435,20.41435,0,0,0,3.92-1.71,6.75155,6.75155,0,0,1-3.7-1.74c.84-2.46,2.18-4.59,4.29-5.63a15.81547,15.81547,0,0,1,13.13-.35s-4.88995-3.57-3.09-5.03c.12.12.24.23.37.34.17.13995.36.29.54.43,1.11.9,2.77-.37,2.99-1.73a4.5857,4.5857,0,0,1,.1-.51c.03-.14.07-.28.11-.41a3.39441,3.39441,0,0,1,.12-.34c3.33-.8,13.4,2.45,17.27,9.61C622.38956,219.56621,649.43954,232.56621,625.57956,260.81621Z",
    transform: "translate(-253.5 -142)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M617.22778,466.37631a8.93378,8.93378,0,0,1,7.32068-10.08344,8.57117,8.57117,0,0,1,1.41312-.10276l24.107-55.98179L666.606,412.62424l-32.19849,53.034a8.909,8.909,0,0,1-7.366,8.00259,8.52587,8.52587,0,0,1-9.77952-7.05282Q617.24333,466.49238,617.22778,466.37631Z",
    transform: "translate(-253.5 -142)",
    fill: "#6c63ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M549.69686,470.93952a8.93377,8.93377,0,0,0-.00564-12.46067,8.57057,8.57057,0,0,0-1.08356-.91287l13.3547-59.47066-20.67673.34075-5.07394,61.83525a8.909,8.909,0,0,0,1.264,10.80284,8.52588,8.52588,0,0,0,12.05738.03276Q549.61612,471.02435,549.69686,470.93952Z",
    transform: "translate(-253.5 -142)",
    fill: "#6c63ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M682.94281,371.3853c-3,4-7-.51-3,5.25,2.75,3.96-13.01,41.08-23.1,63.82-4.56,10.28992-7.97,17.64-7.97,17.64l-17.01-9.8501-1.99-1.1499s15.6-39.26,20.62-53.37c.83-2.34,1.38-3.99,1.51-4.65.94-4.69,1.06-8.71,0-10.2a13.90473,13.90473,0,0,1-.64-1.71c-2.01-5.89-8.13-25.78-13.86-44.59-1.67-5.52-3.32-10.94-4.82-15.89-3.85-12.71-6.74-22.3-6.74-22.3l23,1s.38.64,1.05,1.8c1.6,2.76,4.88,8.45,8.68,15.29,2.74,4.92,5.76,10.45,8.61005,15.89,7.26,13.84,13.51,27.17,11.66,29.02-4,4-8.09,1.73-3.05,6.86C680.94281,369.3853,685.94281,367.3853,682.94281,371.3853Z",
    transform: "translate(-253.5 -142)",
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M655.43958,424.56626c-6-5.94006-4.89-33.01007-4.89-33.01007s5.97-90.9-2.11-96.99a112.67431,112.67431,0,0,0-17.76-10.49c-.36-.16-.55-.25-.55-.25l-5.16-14.55-31.79-1.65-5.55,10.78s-.87.06-2.23.25c-5.08.7-17.02,3.18-15.96,10.91,1.34,9.8-8.12,69.99-11,73s-2.12,14.01,5,21,2,26-3,34a27.3848,27.3848,0,0,0-3.96,16.33991s3.96,21.66015,13.96,14.66015c3.81-2.67016,9.22-3.01,15.73-2.52.06347.00463.13226.01293.196.01782l-.196.98218c9.04.66992,20.21,2.93994,32.16,2.80993l-.35388-1.00452c.11883-.00073.23486.00586.35388.00452,2.02-.02,4.05-.11,6.11-.28992,17.82-1.55,25.69,3.34986,28-2C654.74957,441.21617,661.43958,430.50621,655.43958,424.56626Z",
    transform: "translate(-253.5 -142)",
    fill: "#f2f2f2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.3728,
    cy: 97.09532,
    r: 30,
    fill: "#6c63ff",
    opacity: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M593.44281,284.3853s-4.56,15.14-9.87,32.61c-1.67,5.5-3.42,11.23-5.12,16.80005-5.55,18.11-10.61,34.43-11.08,35.08-1.06,1.49-.93,5.51,0,10.2.19.94-.24,4.6-1.05,9.85-1.06,6.89-2.77,16.51-4.59,26.33-1.45,7.85-2.97,15.82-4.28,22.61005-2.05,10.54-3.58,18.23-3.58,18.23h-19s3.57-79.71,7.57-85.46c4-5.76,0-1.25-3-5.25s2-2,7.04-7.14c5.04-5.13.96-2.86-3.04-6.86-1.48-1.48,1.83-10.91,6.59-22.2,2.22-5.24,4.75-10.88995,7.25-16.32995,5.17-11.23,10.24-21.56,12.25-25.64,0-.01.01-.02.01-.03l.9-1.8Z",
    transform: "translate(-253.5 -142)",
    fill: "#f2f2f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M634.8728,288.09532c-20.879,8.1098-39.65112,9.50775-55,0v-18c18.07686,10.84643,36.41721,10.54986,55,0Z",
    transform: "translate(-253.5 -142)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M650.8728,403.09532c-32.26747,8.1098-61.279,9.50775-85,0v-18c27.937,10.84643,56.28114,10.54986,85,0Z",
    transform: "translate(-253.5 -142)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M656.44281,550.56529c-.17,1.19995-.42,5.28-.71,11.22a147.5843,147.5843,0,0,1-36.45,1.34009l-3.7-17.84009a112.88652,112.88652,0,0,0,37.72.48C656.1228,547.04527,657.2428,544.96531,656.44281,550.56529Z",
    transform: "translate(-253.5 -142)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M592.01282,569.17527a195.43337,195.43337,0,0,1-31.16,4.34l-5.23-7.75-1.12-8.68994a118.57174,118.57174,0,0,0,34.91-4.32007c-.96,4.34009-1.64,7.28-1.64,7.28Z",
    transform: "translate(-253.5 -142)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M594.8728,326.09532a10,10,0,0,1-20,0c0-5.52285,9-17,10-10S594.8728,320.57247,594.8728,326.09532Z",
    transform: "translate(-253.5 -142)",
    fill: "#6c63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M585.96,309.14c-.36-.03-.72-.04-1.09-.04a17.02576,17.02576,0,0,0-16.98,16.11c-.01.29-.02.59-.02.89,0,.41.01.81.05,1.21a16.98729,16.98729,0,0,0,31.24,7.98,15.94718,15.94718,0,0,0,1.04-1.85,16.989,16.989,0,0,0-14.24-24.3ZM597.7,335a16.91771,16.91771,0,0,1-12.83,6.1,15.02174,15.02174,0,0,1-14.88-13.13,14.4398,14.4398,0,0,1-.12-1.87,2.26081,2.26081,0,0,1,.01-.26,15.00184,15.00184,0,0,1,14.99-14.74c.09.24.18.47.28.69,4.27,10.1,13.53,9.34,14.72,14.31a9.8314,9.8314,0,0,1-.98,7.09A11.52084,11.52084,0,0,1,597.7,335Z",
    transform: "translate(-253.5 -142)",
    fill: "#6c63ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M923.81,142H276.19a22.71737,22.71737,0,0,0-22.69,22.69V735.31A22.71737,22.71737,0,0,0,276.19,758H923.81a22.71737,22.71737,0,0,0,22.69-22.69V164.69A22.71737,22.71737,0,0,0,923.81,142ZM944.5,735.31A20.71155,20.71155,0,0,1,923.81,756H276.19a20.71155,20.71155,0,0,1-20.69-20.69V164.69A20.71151,20.71151,0,0,1,276.19,144H923.81a20.71151,20.71151,0,0,1,20.69,20.69Z",
    transform: "translate(-253.5 -142)",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawToTheMoon);
export default __webpack_public_path__ + "static/media/undraw_to_the_moon.4db9ef9bbc634aa8ac1a8ef456840594.svg";
export { ForwardRef as ReactComponent };